// This file is auto-generated by @hey-api/openapi-ts

export type CreateCustomerRequest = {
    name: string;
};

export type CreateResidenceCategoryRequest = {
    name: string;
};

export type CreateResidenceTypeRequest = {
    name: string;
    residenceCategoryId: number;
    roofTypeId: number;
};

export type CreateRoofTypeRequest = {
    name: string;
};

export type CreatedResponse = {
    id: number;
};

export type CustomerModel = {
    id: number;
    name: string;
    assignedResidenceTypeIds: Array<number>;
};

export type CustomerModelPagedList = {
    items: Array<CustomerModel>;
    totalCount: number;
};

export type HttpValidationProblemDetails = {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors: {
        [key: string]: Array<string>;
    };
    [key: string]: unknown | (string | null) | (string | null) | (number | null) | (string | null) | (string | null) | {
        [key: string]: Array<string>;
    } | undefined;
};

export type ImportReportCellModel = {
    id: number;
    state: ImportReportContentState;
    value: string | null;
    issues: Array<ImportReportIssueModel>;
};

export type ImportReportChangeModel = {
    id: number;
    changeType: ImportReportChangeType;
    entityTypeName: string | null;
    columnName: string | null;
    representation: string | null;
    rowIndex: number;
};

export type ImportReportChangeModelPagedList = {
    items: Array<ImportReportChangeModel>;
    totalCount: number;
};

export enum ImportReportChangeType {
    ADDITION = 'Addition',
    UPDATE = 'Update'
}

export type ImportReportColumnModel = {
    id: number;
    index: number;
    name: string | null;
    type: ImportReportColumnType;
};

export enum ImportReportColumnType {
    STRING = 'String',
    NUMBER = 'Number'
}

export enum ImportReportContentState {
    UNMODIFIED = 'Unmodified',
    MODIFIED = 'Modified',
    ADDED = 'Added'
}

export enum ImportReportIssueLevel {
    NOTIFICATION = 'Notification',
    WARNING = 'Warning',
    ERROR = 'Error'
}

export type ImportReportIssueModel = {
    id: number;
    key: string;
    parentKey: string | null;
    level: ImportReportIssueLevel;
    message: string;
    messageTemplate: string | null;
    arguments: Array<string>;
};

export type ImportReportModel = {
    id: number;
    filename: string;
    state: ImportReportState;
    sheets: Array<ImportReportSheetModel>;
    issues: Array<ImportReportIssueModel>;
    changeCount: number;
};

export type ImportReportRowModel = {
    id: number;
    index: number;
    state: ImportReportContentState;
    cells: Array<ImportReportCellModel>;
};

export type ImportReportRowModelPagedList = {
    items: Array<ImportReportRowModel>;
    totalCount: number;
};

export type ImportReportSheetModel = {
    id: number;
    index: number;
    name: string;
    columns: Array<ImportReportColumnModel>;
    issues: Array<ImportReportIssueModel>;
};

export enum ImportReportState {
    FAILED = 'Failed',
    SUCCEEDED = 'Succeeded'
}

export enum ImportRequestMode {
    DRY_RUN = 'DryRun',
    FULL_RUN = 'FullRun'
}

export type ImportRequestModel = {
    id: number;
    mode: ImportRequestMode;
    status: ImportRequestState;
    creationDateTime: string;
    fileReferenceId: number;
    filename: string;
    result: ImportReportState;
    reportId: number | null;
};

export type ImportRequestModelPagedList = {
    items: Array<ImportRequestModel>;
    totalCount: number;
};

export enum ImportRequestState {
    PENDING = 'Pending',
    COMPLETE = 'Complete',
    FAILED = 'Failed'
}

export type ProblemDetails = {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    [key: string]: unknown | (string | null) | (string | null) | (number | null) | (string | null) | (string | null) | undefined;
};

export type ResidenceCategoryModel = {
    id: number;
    name: string;
};

export type ResidenceCategoryModelPagedList = {
    items: Array<ResidenceCategoryModel>;
    totalCount: number;
};

export type ResidenceTypeModel = {
    id: number;
    name: string;
    hasImage: boolean;
    visibility: Visibility;
};

export type ResidenceTypeModelPagedList = {
    items: Array<ResidenceTypeModel>;
    totalCount: number;
};

export type RoofTypeModel = {
    id: number;
    name: string;
};

export type RoofTypeModelPagedList = {
    items: Array<RoofTypeModel>;
    totalCount: number;
};

export type ScenarioModel = {
    id: number;
    name: string;
    residenceTypeId: number;
    residenceTypeName: string;
    situationId: number;
    visibility: Visibility;
    orientation: string;
    relativePosition: string;
};

export type ScenarioModelPagedList = {
    items: Array<ScenarioModel>;
    totalCount: number;
};

export type SituationModel = {
    id: number;
    residenceTypeId: number;
    residenceTypeName: string;
    visibility: Visibility;
    scenarioCount: number;
    orientation: string;
    relativePosition: string;
};

export type SituationModelPagedList = {
    items: Array<SituationModel>;
    totalCount: number;
};

export type UpdateCustomerRequest = {
    name: string;
};

export type UpdateResidenceCategoryRequest = {
    name: string;
};

export type UpdateResidenceTypeRequest = {
    name: string;
    residenceCategoryId: number;
    roofTypeId: number;
};

export type UpdateRoofTypeRequest = {
    name: string;
};

export enum Visibility {
    UNPUBLISHED = 'Unpublished',
    PUBLISHED = 'Published',
    ARCHIVED = 'Archived'
}

export type GetAntiForgeryTokenData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/anti-forgery/token';
};

export type GetAntiForgeryTokenResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetAntiForgeryTokenResponse = GetAntiForgeryTokenResponses[keyof GetAntiForgeryTokenResponses];

export type GetCustomerListData = {
    body?: never;
    path?: never;
    query: {
        residenceTypeId?: number;
        Offset: number;
        Limit: number;
    };
    url: '/api/customers';
};

export type GetCustomerListErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type GetCustomerListError = GetCustomerListErrors[keyof GetCustomerListErrors];

export type GetCustomerListResponses = {
    /**
     * OK
     */
    200: CustomerModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetCustomerListResponse = GetCustomerListResponses[keyof GetCustomerListResponses];

export type CreateCustomerData = {
    body: CreateCustomerRequest;
    path?: never;
    query?: never;
    url: '/api/customers';
};

export type CreateCustomerErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
};

export type CreateCustomerError = CreateCustomerErrors[keyof CreateCustomerErrors];

export type CreateCustomerResponses = {
    /**
     * Created
     */
    201: CreatedResponse;
};

export type CreateCustomerResponse = CreateCustomerResponses[keyof CreateCustomerResponses];

export type DeleteCustomerData = {
    body?: never;
    path: {
        customerId: number;
    };
    query?: never;
    url: '/api/customers/{customerId}';
};

export type DeleteCustomerErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteCustomerResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteCustomerResponse = DeleteCustomerResponses[keyof DeleteCustomerResponses];

export type GetCustomerData = {
    body?: never;
    path: {
        customerId: number;
    };
    query?: never;
    url: '/api/customers/{customerId}';
};

export type GetCustomerErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetCustomerResponses = {
    /**
     * OK
     */
    200: CustomerModel;
};

export type GetCustomerResponse = GetCustomerResponses[keyof GetCustomerResponses];

export type UpdateCustomerData = {
    body: UpdateCustomerRequest;
    path: {
        customerId: number;
    };
    query?: never;
    url: '/api/customers/{customerId}';
};

export type UpdateCustomerErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Not Found
     */
    404: unknown;
};

export type UpdateCustomerError = UpdateCustomerErrors[keyof UpdateCustomerErrors];

export type UpdateCustomerResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type DownloadDataImportFileData = {
    body?: never;
    path: {
        fileReferenceId: number;
    };
    query?: never;
    url: '/api/data-import-files/{fileReferenceId}';
};

export type DownloadDataImportFileErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type UploadDataImportFileData = {
    body?: {
        file: Blob | File;
    };
    path?: never;
    query?: {
        disableNewValueBlocking?: boolean;
    };
    url: '/api/data-import-files';
};

export type UploadDataImportFileErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
};

export type UploadDataImportFileError = UploadDataImportFileErrors[keyof UploadDataImportFileErrors];

export type UploadDataImportFileResponses = {
    /**
     * Accepted
     */
    202: unknown;
};

export type GetImportReportData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/import-reports/{id}';
};

export type GetImportReportErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetImportReportResponses = {
    /**
     * OK
     */
    200: ImportReportModel;
};

export type GetImportReportResponse = GetImportReportResponses[keyof GetImportReportResponses];

export type GetImportReportChangesData = {
    body?: never;
    path: {
        importReportId: number;
    };
    query: {
        Offset: number;
        Limit: number;
    };
    url: '/api/import-reports/{importReportId}/changes';
};

export type GetImportReportChangesErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type GetImportReportChangesError = GetImportReportChangesErrors[keyof GetImportReportChangesErrors];

export type GetImportReportChangesResponses = {
    /**
     * OK
     */
    200: ImportReportChangeModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetImportReportChangesResponse = GetImportReportChangesResponses[keyof GetImportReportChangesResponses];

export type GetImportReportSheetRowsData = {
    body?: never;
    path: {
        importReportSheetId: number;
    };
    query: {
        Offset: number;
        Limit: number;
    };
    url: '/api/import-reports/sheets/{importReportSheetId}/rows';
};

export type GetImportReportSheetRowsErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type GetImportReportSheetRowsError = GetImportReportSheetRowsErrors[keyof GetImportReportSheetRowsErrors];

export type GetImportReportSheetRowsResponses = {
    /**
     * OK
     */
    200: ImportReportRowModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetImportReportSheetRowsResponse = GetImportReportSheetRowsResponses[keyof GetImportReportSheetRowsResponses];

export type GetImportRequestStatusData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/import-requests/{id}';
};

export type GetImportRequestStatusErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetImportRequestStatusResponses = {
    /**
     * OK
     */
    200: ImportRequestModel;
};

export type GetImportRequestStatusResponse = GetImportRequestStatusResponses[keyof GetImportRequestStatusResponses];

export type ConfirmImportRequestData = {
    body?: never;
    path: {
        id: number;
    };
    query: {
        publish: boolean;
        disableNewValueBlocking?: boolean;
    };
    url: '/api/import-requests/{id}';
};

export type ConfirmImportRequestErrors = {
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: string;
};

export type ConfirmImportRequestError = ConfirmImportRequestErrors[keyof ConfirmImportRequestErrors];

export type ConfirmImportRequestResponses = {
    /**
     * Accepted
     */
    202: unknown;
};

export type GetImportRequestStatusListData = {
    body?: never;
    path?: never;
    query: {
        Offset: number;
        Limit: number;
    };
    url: '/api/import-requests';
};

export type GetImportRequestStatusListResponses = {
    /**
     * OK
     */
    200: ImportRequestModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetImportRequestStatusListResponse = GetImportRequestStatusListResponses[keyof GetImportRequestStatusListResponses];

export type DeleteImportRequestData = {
    body?: never;
    path: {
        importRequestId: number;
    };
    query?: never;
    url: '/api/import-requests/{importRequestId}';
};

export type DeleteImportRequestErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteImportRequestResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteImportRequestResponse = DeleteImportRequestResponses[keyof DeleteImportRequestResponses];

export type GetResidenceCategoryListData = {
    body?: never;
    path?: never;
    query: {
        residenceTypeId?: number;
        Offset: number;
        Limit: number;
    };
    url: '/api/residence-categories';
};

export type GetResidenceCategoryListErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type GetResidenceCategoryListError = GetResidenceCategoryListErrors[keyof GetResidenceCategoryListErrors];

export type GetResidenceCategoryListResponses = {
    /**
     * OK
     */
    200: ResidenceCategoryModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetResidenceCategoryListResponse = GetResidenceCategoryListResponses[keyof GetResidenceCategoryListResponses];

export type CreateResidenceCategoryData = {
    body: CreateResidenceCategoryRequest;
    path?: never;
    query?: never;
    url: '/api/residence-categories';
};

export type CreateResidenceCategoryErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
};

export type CreateResidenceCategoryError = CreateResidenceCategoryErrors[keyof CreateResidenceCategoryErrors];

export type CreateResidenceCategoryResponses = {
    /**
     * Created
     */
    201: CreatedResponse;
};

export type CreateResidenceCategoryResponse = CreateResidenceCategoryResponses[keyof CreateResidenceCategoryResponses];

export type DeleteResidenceCategoryData = {
    body?: never;
    path: {
        residenceCategoryId: number;
    };
    query?: never;
    url: '/api/residence-categories/{residenceCategoryId}';
};

export type DeleteResidenceCategoryErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteResidenceCategoryResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteResidenceCategoryResponse = DeleteResidenceCategoryResponses[keyof DeleteResidenceCategoryResponses];

export type GetResidenceCategoryData = {
    body?: never;
    path: {
        residenceCategoryId: number;
    };
    query?: never;
    url: '/api/residence-categories/{residenceCategoryId}';
};

export type GetResidenceCategoryErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetResidenceCategoryResponses = {
    /**
     * OK
     */
    200: ResidenceCategoryModel;
};

export type GetResidenceCategoryResponse = GetResidenceCategoryResponses[keyof GetResidenceCategoryResponses];

export type UpdateResidenceCategoryData = {
    body: UpdateResidenceCategoryRequest;
    path: {
        residenceCategoryId: number;
    };
    query?: never;
    url: '/api/residence-categories/{residenceCategoryId}';
};

export type UpdateResidenceCategoryErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Not Found
     */
    404: unknown;
};

export type UpdateResidenceCategoryError = UpdateResidenceCategoryErrors[keyof UpdateResidenceCategoryErrors];

export type UpdateResidenceCategoryResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetResidenceTypeListData = {
    body?: never;
    path?: never;
    query: {
        Offset: number;
        Limit: number;
    };
    url: '/api/residence-types';
};

export type GetResidenceTypeListErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type GetResidenceTypeListError = GetResidenceTypeListErrors[keyof GetResidenceTypeListErrors];

export type GetResidenceTypeListResponses = {
    /**
     * OK
     */
    200: ResidenceTypeModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetResidenceTypeListResponse = GetResidenceTypeListResponses[keyof GetResidenceTypeListResponses];

export type CreateResidenceTypeData = {
    body: CreateResidenceTypeRequest;
    path?: never;
    query?: never;
    url: '/api/residence-types';
};

export type CreateResidenceTypeErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: unknown;
};

export type CreateResidenceTypeError = CreateResidenceTypeErrors[keyof CreateResidenceTypeErrors];

export type CreateResidenceTypeResponses = {
    /**
     * Created
     */
    201: CreatedResponse;
};

export type CreateResidenceTypeResponse = CreateResidenceTypeResponses[keyof CreateResidenceTypeResponses];

export type DeleteResidenceTypeData = {
    body?: never;
    path: {
        residenceTypeId: number;
    };
    query?: never;
    url: '/api/residence-types/{residenceTypeId}';
};

export type DeleteResidenceTypeErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteResidenceTypeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteResidenceTypeResponse = DeleteResidenceTypeResponses[keyof DeleteResidenceTypeResponses];

export type GetResidenceTypeData = {
    body?: never;
    path: {
        residenceTypeId: number;
    };
    query?: never;
    url: '/api/residence-types/{residenceTypeId}';
};

export type GetResidenceTypeErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetResidenceTypeResponses = {
    /**
     * OK
     */
    200: ResidenceTypeModel;
};

export type GetResidenceTypeResponse = GetResidenceTypeResponses[keyof GetResidenceTypeResponses];

export type UpdateResidenceTypeData = {
    body: UpdateResidenceTypeRequest;
    path: {
        residenceTypeId: number;
    };
    query?: never;
    url: '/api/residence-types/{residenceTypeId}';
};

export type UpdateResidenceTypeErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: unknown;
};

export type UpdateResidenceTypeError = UpdateResidenceTypeErrors[keyof UpdateResidenceTypeErrors];

export type UpdateResidenceTypeResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetUnpublishedResidenceTypeWithNoImageListData = {
    body?: never;
    path?: never;
    query: {
        Offset: number;
        Limit: number;
    };
    url: '/api/residence-types/unpublished-no-image';
};

export type GetUnpublishedResidenceTypeWithNoImageListErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type GetUnpublishedResidenceTypeWithNoImageListError = GetUnpublishedResidenceTypeWithNoImageListErrors[keyof GetUnpublishedResidenceTypeWithNoImageListErrors];

export type GetUnpublishedResidenceTypeWithNoImageListResponses = {
    /**
     * OK
     */
    200: ResidenceTypeModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetUnpublishedResidenceTypeWithNoImageListResponse = GetUnpublishedResidenceTypeWithNoImageListResponses[keyof GetUnpublishedResidenceTypeWithNoImageListResponses];

export type GetResidenceTypeImageData = {
    body?: never;
    path: {
        residenceTypeId: number;
    };
    query?: never;
    url: '/api/residence-types/{residenceTypeId}/image';
};

export type GetResidenceTypeImageErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetResidenceTypeImageResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetResidenceTypeImageResponse = GetResidenceTypeImageResponses[keyof GetResidenceTypeImageResponses];

export type UploadImageForResidenceTypeData = {
    body?: {
        file: Blob | File;
    };
    path: {
        residenceTypeId: number;
    };
    query?: never;
    url: '/api/residence-types/{residenceTypeId}/image';
};

export type UploadImageForResidenceTypeErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: unknown;
};

export type UploadImageForResidenceTypeError = UploadImageForResidenceTypeErrors[keyof UploadImageForResidenceTypeErrors];

export type UploadImageForResidenceTypeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UploadImageForResidenceTypeResponse = UploadImageForResidenceTypeResponses[keyof UploadImageForResidenceTypeResponses];

export type GetAssignedCustomerListFromResidenceTypeData = {
    body?: never;
    path: {
        residenceTypeId: number;
    };
    query: {
        Offset: number;
        Limit: number;
    };
    url: '/api/residence-types/{residenceTypeId}/assigned-customers';
};

export type GetAssignedCustomerListFromResidenceTypeErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: unknown;
};

export type GetAssignedCustomerListFromResidenceTypeError = GetAssignedCustomerListFromResidenceTypeErrors[keyof GetAssignedCustomerListFromResidenceTypeErrors];

export type GetAssignedCustomerListFromResidenceTypeResponses = {
    /**
     * OK
     */
    200: CustomerModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetAssignedCustomerListFromResidenceTypeResponse = GetAssignedCustomerListFromResidenceTypeResponses[keyof GetAssignedCustomerListFromResidenceTypeResponses];

export type AssignCustomerToResidenceTypeData = {
    body?: never;
    path: {
        residenceTypeId: number;
    };
    query: {
        customerId: number;
    };
    url: '/api/residence-types/{residenceTypeId}/assigned-customers';
};

export type AssignCustomerToResidenceTypeErrors = {
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: string;
};

export type AssignCustomerToResidenceTypeError = AssignCustomerToResidenceTypeErrors[keyof AssignCustomerToResidenceTypeErrors];

export type AssignCustomerToResidenceTypeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type AssignCustomerToResidenceTypeResponse = AssignCustomerToResidenceTypeResponses[keyof AssignCustomerToResidenceTypeResponses];

export type UnassignCustomerFromResidenceTypeData = {
    body?: never;
    path: {
        residenceTypeId: number;
        customerId: number;
    };
    query?: never;
    url: '/api/residence-types/{residenceTypeId}/assigned-customers/{customerId}';
};

export type UnassignCustomerFromResidenceTypeErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type UnassignCustomerFromResidenceTypeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UnassignCustomerFromResidenceTypeResponse = UnassignCustomerFromResidenceTypeResponses[keyof UnassignCustomerFromResidenceTypeResponses];

export type PublishResidenceTypeData = {
    body?: never;
    path: {
        residenceTypeId: number;
    };
    query?: never;
    url: '/api/residence-types/{residenceTypeId}/publish';
};

export type PublishResidenceTypeErrors = {
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: string;
};

export type PublishResidenceTypeError = PublishResidenceTypeErrors[keyof PublishResidenceTypeErrors];

export type PublishResidenceTypeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PublishResidenceTypeResponse = PublishResidenceTypeResponses[keyof PublishResidenceTypeResponses];

export type UnpublishResidenceTypeData = {
    body?: never;
    path: {
        residenceTypeId: number;
    };
    query?: never;
    url: '/api/residence-types/{residenceTypeId}/unpublish';
};

export type UnpublishResidenceTypeErrors = {
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: string;
};

export type UnpublishResidenceTypeError = UnpublishResidenceTypeErrors[keyof UnpublishResidenceTypeErrors];

export type UnpublishResidenceTypeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UnpublishResidenceTypeResponse = UnpublishResidenceTypeResponses[keyof UnpublishResidenceTypeResponses];

export type ArchiveResidenceTypeData = {
    body?: never;
    path: {
        residenceTypeId: number;
    };
    query?: never;
    url: '/api/residence-types/{residenceTypeId}/archive';
};

export type ArchiveResidenceTypeErrors = {
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: string;
};

export type ArchiveResidenceTypeError = ArchiveResidenceTypeErrors[keyof ArchiveResidenceTypeErrors];

export type ArchiveResidenceTypeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ArchiveResidenceTypeResponse = ArchiveResidenceTypeResponses[keyof ArchiveResidenceTypeResponses];

export type GetRoofTypeListData = {
    body?: never;
    path?: never;
    query: {
        residenceTypeId?: number;
        Offset: number;
        Limit: number;
    };
    url: '/api/roof-types';
};

export type GetRoofTypeListErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type GetRoofTypeListError = GetRoofTypeListErrors[keyof GetRoofTypeListErrors];

export type GetRoofTypeListResponses = {
    /**
     * OK
     */
    200: RoofTypeModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetRoofTypeListResponse = GetRoofTypeListResponses[keyof GetRoofTypeListResponses];

export type CreateRoofTypeData = {
    body: CreateRoofTypeRequest;
    path?: never;
    query?: never;
    url: '/api/roof-types';
};

export type CreateRoofTypeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
};

export type CreateRoofTypeError = CreateRoofTypeErrors[keyof CreateRoofTypeErrors];

export type CreateRoofTypeResponses = {
    /**
     * Created
     */
    201: CreatedResponse;
};

export type CreateRoofTypeResponse = CreateRoofTypeResponses[keyof CreateRoofTypeResponses];

export type DeleteRoofTypeData = {
    body?: never;
    path: {
        roofTypeId: number;
    };
    query?: never;
    url: '/api/roof-types/{roofTypeId}';
};

export type DeleteRoofTypeErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteRoofTypeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteRoofTypeResponse = DeleteRoofTypeResponses[keyof DeleteRoofTypeResponses];

export type GetRoofTypeData = {
    body?: never;
    path: {
        roofTypeId: number;
    };
    query?: never;
    url: '/api/roof-types/{roofTypeId}';
};

export type GetRoofTypeErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetRoofTypeResponses = {
    /**
     * OK
     */
    200: RoofTypeModel;
};

export type GetRoofTypeResponse = GetRoofTypeResponses[keyof GetRoofTypeResponses];

export type UpdateRoofTypeData = {
    body: UpdateRoofTypeRequest;
    path: {
        roofTypeId: number;
    };
    query?: never;
    url: '/api/roof-types/{roofTypeId}';
};

export type UpdateRoofTypeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Not Found
     */
    404: unknown;
};

export type UpdateRoofTypeError = UpdateRoofTypeErrors[keyof UpdateRoofTypeErrors];

export type UpdateRoofTypeResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetScenarioListData = {
    body?: never;
    path?: never;
    query: {
        situationId?: number;
        Offset: number;
        Limit: number;
    };
    url: '/api/scenarios';
};

export type GetScenarioListErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type GetScenarioListError = GetScenarioListErrors[keyof GetScenarioListErrors];

export type GetScenarioListResponses = {
    /**
     * OK
     */
    200: ScenarioModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetScenarioListResponse = GetScenarioListResponses[keyof GetScenarioListResponses];

export type GetScenarioData = {
    body?: never;
    path: {
        scenarioId: number;
    };
    query?: never;
    url: '/api/scenarios/{scenarioId}';
};

export type GetScenarioErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetScenarioResponses = {
    /**
     * OK
     */
    200: ScenarioModel;
};

export type GetScenarioResponse = GetScenarioResponses[keyof GetScenarioResponses];

export type PublishScenarioData = {
    body?: never;
    path: {
        scenarioId: number;
    };
    query?: never;
    url: '/api/scenarios/{scenarioId}/publish';
};

export type PublishScenarioErrors = {
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: string;
};

export type PublishScenarioError = PublishScenarioErrors[keyof PublishScenarioErrors];

export type PublishScenarioResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PublishScenarioResponse = PublishScenarioResponses[keyof PublishScenarioResponses];

export type UnpublishScenarioData = {
    body?: never;
    path: {
        scenarioId: number;
    };
    query?: never;
    url: '/api/scenarios/{scenarioId}/unpublish';
};

export type UnpublishScenarioErrors = {
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: string;
};

export type UnpublishScenarioError = UnpublishScenarioErrors[keyof UnpublishScenarioErrors];

export type UnpublishScenarioResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UnpublishScenarioResponse = UnpublishScenarioResponses[keyof UnpublishScenarioResponses];

export type GetSituationListData = {
    body?: never;
    path?: never;
    query: {
        residenceTypeId?: number;
        Offset: number;
        Limit: number;
    };
    url: '/api/situations';
};

export type GetSituationListErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type GetSituationListError = GetSituationListErrors[keyof GetSituationListErrors];

export type GetSituationListResponses = {
    /**
     * OK
     */
    200: SituationModelPagedList;
    /**
     * No Content
     */
    204: void;
};

export type GetSituationListResponse = GetSituationListResponses[keyof GetSituationListResponses];

export type GetSituationData = {
    body?: never;
    path: {
        situationId: number;
    };
    query?: never;
    url: '/api/situations/{situationId}';
};

export type GetSituationErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetSituationResponses = {
    /**
     * OK
     */
    200: SituationModel;
};

export type GetSituationResponse = GetSituationResponses[keyof GetSituationResponses];

export type PublishSituationData = {
    body?: never;
    path: {
        situationId: number;
    };
    query?: never;
    url: '/api/situations/{situationId}/publish';
};

export type PublishSituationErrors = {
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: string;
};

export type PublishSituationError = PublishSituationErrors[keyof PublishSituationErrors];

export type PublishSituationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PublishSituationResponse = PublishSituationResponses[keyof PublishSituationResponses];

export type UnpublishSituationData = {
    body?: never;
    path: {
        situationId: number;
    };
    query?: never;
    url: '/api/situations/{situationId}/unpublish';
};

export type UnpublishSituationErrors = {
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: string;
};

export type UnpublishSituationError = UnpublishSituationErrors[keyof UnpublishSituationErrors];

export type UnpublishSituationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UnpublishSituationResponse = UnpublishSituationResponses[keyof UnpublishSituationResponses];

export type ClientOptions = {
    baseUrl: 'http://localhost:5092' | (string & {});
};